/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderListItemPaginationWrapper,
    ProviderListItemPaginationWrapperFromJSON,
    ProviderListItemPaginationWrapperToJSON,
    ProviderListQuery,
    ProviderListQueryFromJSON,
    ProviderListQueryToJSON,
    ProviderState,
    ProviderStateFromJSON,
    ProviderStateToJSON,
    ProviderStateResponse,
    ProviderStateResponseFromJSON,
    ProviderStateResponseToJSON,
} from '../models';

export interface ApiProviderListDataPostRequest {
    providerListQuery?: ProviderListQuery;
}

export interface ApiProviderListUpdateStateBulkPostRequest {
    providerState?: Array<ProviderState>;
}

/**
 * no description
 */
export class ProviderListApi extends runtime.BaseAPI {

    /**
     */
    async apiProviderListDataPostRaw(requestParameters: ApiProviderListDataPostRequest): Promise<runtime.ApiResponse<ProviderListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderListQueryToJSON(requestParameters.providerListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderListDataPost(requestParameters: ApiProviderListDataPostRequest): Promise<ProviderListItemPaginationWrapper> {
        const response = await this.apiProviderListDataPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiProviderListUpdateStateBulkPostRaw(requestParameters: ApiProviderListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<ProviderStateResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderList/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.providerState.map(ProviderStateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderStateResponseFromJSON));
    }

    /**
     */
    async apiProviderListUpdateStateBulkPost(requestParameters: ApiProviderListUpdateStateBulkPostRequest): Promise<Array<ProviderStateResponse>> {
        const response = await this.apiProviderListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

}
